class RecovryCartUpsell extends HTMLElement {
  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  connectedCallback() {
    this.button = this.querySelector('[data-rec-up-add]');
    this.message = this.querySelector('[data-rec-up-message]');
    this.addEventListener('change', this.handleChange);
    this.button?.addEventListener('click', this.handleSubmit);
    this.handleChange();
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.handleChange);
    this.button?.removeEventListener('click', this.handleSubmit);
  }

  get selectedItems() {
    return [...this.querySelectorAll('[data-rec-up-check]:checked')].map((checkbox) => {
      const item = checkbox.closest('[data-rec-up-item]');
      const select = item?.querySelector('[data-rec-up-variant]');

      return {
        id: Number(select?.value || checkbox.dataset.variantId),
        quantity: 1,
      };
    }).filter((item) => Number.isInteger(item.id) && item.id > 0);
  }

  handleChange() {
    if (!this.button) return;
    this.button.disabled = this.selectedItems.length === 0;
  }

  showMessage(text, isError = false) {
    if (!this.message) return;
    this.message.hidden = !text;
    this.message.textContent = text || '';
    this.message.style.color = isError ? '#b42318' : '';
  }

  async handleSubmit() {
    const items = this.selectedItems;
    if (!items.length || !this.button || this.button.disabled) return;

    const originalText = this.button.textContent;
    this.button.disabled = true;
    this.button.textContent = 'Wird hinzugefügt …';
    this.showMessage('');

    try {
      const sections = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } })
      );

      const response = await fetch(FoxTheme.routes.cart_add_url, {
        ...FoxTheme.utils.fetchConfig('javascript'),
        body: JSON.stringify({
          items,
          sections,
          sections_url: window.location.pathname,
        }),
      });
      const parsedState = await response.json();

      if (!response.ok || parsedState.status) {
        throw new Error(parsedState.description || 'Die Auswahl konnte nicht hinzugefügt werden.');
      }

      const cartResponse = await fetch(FoxTheme.routes.cart_url, FoxTheme.utils.fetchConfig());
      const cart = await cartResponse.json();
      cart.sections = parsedState.sections;

      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart });
      document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: parsedState } }));
    } catch (error) {
      this.showMessage(error.message || 'Die Auswahl konnte nicht hinzugefügt werden.', true);
      this.button.disabled = false;
      this.button.textContent = originalText;
    }
  }
}

if (!customElements.get('recovry-cart-upsell')) {
  customElements.define('recovry-cart-upsell', RecovryCartUpsell);
}
